module.exports = __webpack_public_path__ + "static/img/logo2.27c8227.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/head/logo2.gif
// module id = dsYa
// module chunks = 27